import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon, TrendingDownIcon, ClockIcon, CpuIcon } from 'lucide-react';
import { SlideLayout, itemVariants } from '../ui/SlideLayout';
export function ProblemSlide() {
  return <SlideLayout data-id="element-353" data-mp="gy06u7dw54qp">
      <motion.div variants={itemVariants} className="mb-16" data-id="element-354" data-mp="gyi5tbrxtx2b">
        <h2 className="text-4xl md:text-5xl font-bold text-brand-text mb-6" data-id="element-355" data-mp="kysckqnk0ri8">
          GPUs Became the Default by Convenience,{' '}
          <span className="text-brand-text-muted" data-id="element-356" data-mp="18pob06mimkyg">Not by Design</span>
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-357" data-mp="1dosoh9gh34ul">
        <motion.div variants={itemVariants} className="lg:col-span-7 space-y-8" data-id="element-358" data-mp="zurt8poqbzyz">
          <div className="flex gap-4 items-start" data-id="element-359" data-mp="13vk57qozkiyy">
            <div className="mt-1 p-2 bg-brand-bg-card rounded-lg border border-brand-border text-brand-teal" data-id="element-360" data-mp="1rmh688f8tvvf">
              <CpuIcon className="w-6 h-6" data-id="element-361" data-mp="1wcxlly2mjrkf" />
            </div>
            <div data-id="element-362" data-mp="1weh3tu7uccou">
              <h3 className="text-xl font-semibold text-brand-text mb-2" data-id="element-363" data-mp="1wf0gowimwaw0">
                Inherited from Training
              </h3>
              <p className="text-brand-text-dim leading-relaxed" data-id="element-364" data-mp="iemm10q4tx21">
                There is a GPU in every computer, making it the natural place
                for large matrix multiplications. But inference workloads are
                fundamentally different from training.
              </p>
            </div>
          </div>

          <div className="flex gap-4 items-start" data-id="element-365" data-mp="161upre7wwy1y">
            <div className="mt-1 p-2 bg-brand-bg-card rounded-lg border border-brand-border text-brand-teal" data-id="element-366" data-mp="12242vllib22p">
              <TrendingDownIcon className="w-6 h-6" data-id="element-367" data-mp="1g254525oobip" />
            </div>
            <div data-id="element-368" data-mp="1fz93h62gb8qk">
              <h3 className="text-xl font-semibold text-brand-text mb-2" data-id="element-369" data-mp="1b2s9vwchg263">
                Poor Utilization at Scale
              </h3>
              <p className="text-brand-text-dim leading-relaxed" data-id="element-370" data-mp="3htrowlyzfa6q">
                Cloud GPU costs dominate AI budgets. Utilization rates are often
                20–30% for real-time workloads running at low batch sizes.
              </p>
            </div>
          </div>

          <div className="flex gap-4 items-start" data-id="element-371" data-mp="1lpbwtfdq429t">
            <div className="mt-1 p-2 bg-brand-bg-card rounded-lg border border-brand-border text-brand-teal" data-id="element-372" data-mp="1lry032tkzvm8">
              <ClockIcon className="w-6 h-6" data-id="element-373" data-mp="1ptrz76o4orka" />
            </div>
            <div data-id="element-374" data-mp="1urbf0b0h5cec">
              <h3 className="text-xl font-semibold text-brand-text mb-2" data-id="element-375" data-mp="1urtdzfeiu4py">
                Unpredictable Latency
              </h3>
              <p className="text-brand-text-dim leading-relaxed" data-id="element-376" data-mp="24og0s9qer5um">
                Non-deterministic scheduling causes latency spikes (jitter) that
                break SLAs for real-time applications like voice agents and
                trading systems.
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div variants={itemVariants} className="lg:col-span-5" data-id="element-377" data-mp="2igvz4x8d6fp7">
          <div className="bg-brand-bg-card border border-brand-border rounded-2xl p-8 relative overflow-hidden" data-id="element-378" data-mp="2nexr67nrppct">
            <div className="absolute top-0 right-0 w-32 h-32 bg-brand-teal/10 blur-3xl rounded-full" data-id="element-379" data-mp="2xjnmvvskvx8l" />

            <div className="mb-6" data-id="element-380" data-mp="2sjrrum1uzg56">
              <AlertCircleIcon className="w-8 h-8 text-brand-teal mb-4" data-id="element-381" data-mp="2sigfhxucl02g" />
              <h3 className="text-2xl font-bold text-brand-text mb-2" data-id="element-382" data-mp="2nlzpey3l8bmq">
                The Industry is Moving
              </h3>
              <p className="text-brand-text-dim" data-id="element-383" data-mp="2jl61i4q5awtu">
                ~30% of inference today already runs on non-GPU platforms
                (ASICs, custom silicon).
              </p>
            </div>

            <div className="mt-8 pt-8 border-t border-brand-border" data-id="element-384" data-mp="3bbas4l4i0g3i">
              <div className="text-5xl font-bold text-brand-teal mb-4" data-id="element-385" data-mp="36ir6r1zkkgo5">50%</div>
              <p className="text-lg text-brand-text font-medium mb-1" data-id="element-386" data-mp="32iqsbhch05h3">
                of AI inference will run on non-GPU platforms by 2027
              </p>
              <p className="text-sm text-brand-text-muted" data-id="element-387" data-mp="2wtuu8g0bqb8">— Goldman Sachs</p>
            </div>
          </div>
        </motion.div>
      </div>
    </SlideLayout>;
}